
export enum Status {
  NEW = 'New',
  MP = 'MP'
}

export enum Millsheet {
  Y = 'Y',
  N = 'N',
  X = 'X'
}

export interface ItemFile {
  id: string;
  displayName: string;
  fileName: string;
  url: string;
  type: 'PDF' | 'IMDS' | 'ROHS' | 'STANDARD_DOC' | 'MILLSHEET';
}

export interface CustomField {
  id: string;
  label: string;
  value: string;
}

export interface ItemDetail {
  pdfs: ItemFile[];
  customFields: CustomField[];
  imdsFile?: ItemFile;
  rohsFile?: ItemFile;
  millsheetFile?: ItemFile;
  rohsComposition?: {
    [key: string]: string | undefined;
  };
  rohsLimits?: {
    [key: string]: number | undefined;
  };
  rohsUnits?: {
    [key: string]: string | undefined;
  };
}

export interface DwgData {
  customer: string;
  dwg_number: string;
  hr_mark: string;
  status: Status;
}

export interface ImdsNode {
  treeLevel?: number;
  description?: string;
  articleName?: string;
  name?: string;
  substanceName?: string;
  partItemNo?: string;
  itemMatNo?: string;
  materialNo?: string;
  casNo?: string;
  imdsIdVersion?: string;
  quantity?: number;
  weight?: number;
  portion?: number;
  portionRange?: string;
  classification?: string;
  gadslSvhc?: string;
  partsMarking?: string;
  sourceOfMaterial?: string;
  applicationId?: string;
  recyclate?: string;
}

export interface MdsItem {
  no: number;
  level: number;
  part_number_customer: string;
  part_number_idbm: string;
  part_name_customer: string;
  part_name_idbm: string;
  hr_mark_item?: string;
  qty_r: number;
  qty_l: number;
  qty_total: number;
  status: Status;
  uom: string;
  berat_level: number; 
  berat_total: number; 
  material: string;
  millsheet: Millsheet;
  manufacturer: string;
  parent_part_number: string;
  imds_number?: string;
  rohs_test?: string;
  rohs_expiry?: string;
  children?: MdsItem[];
  details?: ItemDetail;
  imdsData?: ImdsNode;
}

export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export interface ProcessedMds {
  dwg: DwgData;
  items: MdsItem[];
  tree: MdsItem[];
  summary: {
    totalItems: number;
    maxLevel: number;
    totalWeight: number;
  };
  uploadedAt: string;
}

export interface StandardLimit {
  id: string;
  materialCategory: string;
  substance: string;
  limitValue: number;
  unit: string;
  operator: string;
}

export interface RegulatoryRow {
  gadslNo: string;
  substance: string;
  casNumber: string;
  hondaApplication: string; // Application of Honda Criteria (Materials/Parts)
  imdsAppId: string;       // IMDS Application ID
  hondaCriteria: string;    // Honda Criteria (Content rate or Due date etc.)
  mainApplications: string; // Example of main applications (reference)
  relevantLaws: string;     // Major Relevant Laws and Regulations (reference)
}

export interface ImdsStandard {
  id: string;
  standard_id: string;
  standardName: string;
  ownerCompany: string;
  type: 'OEM' | 'REGULATORY' | 'INTERNAL';
  status: string;
  limits: StandardLimit[];
  regulatoryRows: RegulatoryRow[];
  technicalNotes?: string;
  version?: string;
  effectiveDate?: string;
  documents?: any[];
}

export interface AnalysisResult {
  id: string;
  partNumber: string;
  partName: string;
  standardName: string;
  ownerCompany: string;
  substance: string;
  actualValue: number;
  limitValue: number;
  unit: string;
  status: 'COMPLY' | 'MARGINAL' | 'EXCEED';
  dwgReference: string;
  regulatoryInfo: string;
  timestamp: string;
}
